










































import { Vue, Component, Ref, Watch } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { Student, StudentList as IStudentList } from "@/api-v2/course/models";
import CustomTable from "@/components/form/CustomTable.vue";
import StudentListItem from "@/components/students/StudentListItem.vue";
import { StudentsListParams } from "@/getinfo-api/students";
import CField from "@/components/form/CField.vue";
import { UsersListClass } from "@/classes/list/UsersListClass";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import StudentTable from "@/components/students/StudentTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import Modal from "@/components/form/Modal.vue";
import { getCurrentCompanyId } from "@/plugins/roles";

@Component({
  components: {
    Modal,
    CustomButton,
    StudentTable,
    CSingleSelect,
    CField,
    StudentListItem,
    CustomTable,
    CBlock,
    CPage
  }
})
export default class StudentsList extends Vue {
  @Ref("studentTable") StudentTable!: StudentTable;
  students!: IStudentList;
  isLoading: boolean = false;
  userId!: string | undefined;
  usersList: UsersListClass = new UsersListClass({});
  checkedStudents: Student[] = [];
  form: StudentsListParams = {
    offset: 0,
    limit: 15,
    userIds: [],
    companyId: getCurrentCompanyId()
  };

  data() {
    return {
      students: undefined,
      userId: undefined
    };
  }

  applyFilter() {
    this.form.offset = 0;
    if (this.userId) {
      this.form.userIds = [this.userId];
    }
  }

  clearFilter() {
    this.form = {
      offset: 0,
      limit: 15
    };
    this.userId = undefined;
  }

  @Watch("userId")
  checkUserId() {
    this.form.userIds = this.userId ? [this.userId] : [];
  }
}
